import React from 'react';
import { FaMapMarkerAlt, FaTimes } from 'react-icons/fa';
import { useDarkMode } from '../hooks/useDarkMode';

const LocationPermissionModal = ({ isOpen, onAllow, onSkip, onClose }) => {
  const { isDarkMode } = useDarkMode();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div
        className={` rounded-2xl shadow-2xl max-w-md w-full p-6 relative animate-slideUp ${
          isDarkMode ? 'bg-gray-800 text-gray-200' : 'bg-white'
        }`}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 transition-colors hover:text-gray-600 text-gray-400"
          aria-label="Close"
        >
          <FaTimes className="text-xl" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div
            className={`p-4 rounded-full ${isDarkMode ? 'bg-gray-700' : 'bg-green-100'}`}
          >
            <FaMapMarkerAlt className="text-4xl" style={{ color: isDarkMode ? '#3b8200' : '#3b8200' }} />
          </div>
        </div>

        {/* Title */}
        <h2 className={`text-2xl font-bold mb-3 text-center ${
          isDarkMode ? 'text-white' : 'text-gray-800'
        }`}>
          Enable Location
        </h2>

        {/* Description */}
        <p className={`mb-6 text-center ${
          isDarkMode ? 'text-gray-300' : 'text-gray-600'
        }`}>
          We'd like to access your location to provide personalized SEO results and recommendations based on your country.
        </p>

        {/* Benefits list */}
        <div className={`p-4 mb-6 rounded-lg ${
          isDarkMode ? 'bg-gray-700' : 'bg-green-50'
        }`}>
          <p className="text-sm font-semibold mb-2">Benefits:</p>
          <ul className="text-sm space-y-1">
            <li className="flex items-start">
              <span className={`text-green-600 mr-2 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>✓</span>
              <span>Country-specific SEO recommendations</span>
            </li>
            <li className="flex items-start">
              <span className={`text-green-600 mr-2 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>✓</span>
              <span>Localized keyword suggestions</span>
            </li>
            <li className="flex items-start">
              <span className={`text-green-600 mr-2 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>✓</span>
              <span>Regional search trends and insights</span>
            </li>
          </ul>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3 mb-4">
          <button
            onClick={onAllow}
            className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-3 rounded-lg font-semibold hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Allow Location Access
          </button>
          <button
            onClick={onSkip}
            className="w-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 py-3 rounded-lg font-semibold hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            Skip for Now
          </button>
        </div>

        {/* Privacy note */}
        <p className={`text-xs text-center mt-4 ${
          isDarkMode ? 'text-gray-400' : 'text-gray-500'
        }`}>
          We respect your privacy. Your location is only used to enhance your experience and is stored locally on your device.
        </p>
      </div>
    </div>
  );
};

export default LocationPermissionModal;
